import { Fold } from "@discovery/prelude/lib/control/lens";
import * as Optics from "@discovery/sonic-api-ng-optics";
import * as M from "@discovery/prelude/lib/data/maybe";
export const _LiveTvChannelName = Fold.compose(Optics._Col2Items, Optics._ColItem2Channel, Fold.liftM((attributes) => ({
    name: attributes.name,
    packages: M.of(attributes.packages),
}), Optics._Channel2Attributes));

